import { CSSProperties } from 'react';
import { ExternalLinkMenuComponent } from './external-link-menu/external-link-menu.component';
import { InternalLinkMenuComponent } from './internal-link-menu/internal-link-menu.component';
import { LogoComponent } from './logo.component';
import { AssignedAppTypeEnum } from '@vivli/shared/infrastructure/enum';
import { PortalTitleComponent } from './portal-title.component';
import { useAppConfigContext, useAssignedAppTypeContext } from '@vivli/core/infrastructure/context';
import { useEnvironmentTitle } from '@vivli/core/infrastructure/hook';

const externalLinksContainerStyle: CSSProperties = {
    maxHeight: 75,
    minHeight: 75,
    backgroundColor: 'white',
    display: 'flex',
    justifyContent: 'space-between'
};

interface HeaderComponentProps {
    onFindStudiesClick: () => void;
}

export const HeaderComponent = ({ onFindStudiesClick }: HeaderComponentProps) => {
    const { viewRequestResultsOnly } = useAppConfigContext();
    const { isAmr } = useAssignedAppTypeContext();
    useEnvironmentTitle();

    return (
        <div className="do-not-print" style={{ zIndex: 101 }}>
            <div style={externalLinksContainerStyle}>
                <LogoComponent />
                <PortalTitleComponent />
                {!viewRequestResultsOnly && !isAmr && <ExternalLinkMenuComponent onFindStudiesClick={onFindStudiesClick} />}
            </div>
            <InternalLinkMenuComponent />
        </div>
    );
};
